import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../layout/Layout.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Users from '../views/Users.vue';
import Recharges from '../views/Recharges.vue';
import AgentRechargeOrders from '../views/AgentRechargeOrders.vue';
import PlayerTopup from '../views/PlayerTopup.vue';
import Withdraws from '../views/Withdraws.vue';
import EarningsWithdrawOrders from '../views/EarningsWithdrawOrders.vue';
import Commission from '../views/Commission.vue';
import Settlements from '../views/Settlements.vue';
import WalletRecords from '../views/WalletRecords.vue';
import { getToken } from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', component: Dashboard, meta: { titleKey: 'menu.dashboard' } },
        { path: 'users', component: Users, meta: { titleKey: 'menu.users' } },
        { path: 'recharges', component: Recharges, meta: { titleKey: 'menu.recharges' } },
        { path: 'agent-recharge-orders', component: AgentRechargeOrders, meta: { titleKey: 'menu.agentRechargeOrders' } },
        { path: 'player-topup', component: PlayerTopup, meta: { titleKey: 'menu.playerTopup' } },
        { path: 'withdraws', component: Withdraws, meta: { titleKey: 'menu.withdraws' } },
        { path: 'earnings-withdraw-orders', component: EarningsWithdrawOrders, meta: { titleKey: 'menu.earningsWithdrawOrders' } },
        { path: 'commission', component: Commission, meta: { titleKey: 'menu.commission' } },
        { path: 'settlements', component: Settlements, meta: { titleKey: 'menu.settlements' } },
        { path: 'wallet-records', component: WalletRecords, meta: { titleKey: 'menu.walletRecords' } }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !getToken()) {
    next('/login');
    return;
  }
  if (to.path === '/login' && getToken()) {
    next('/dashboard');
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js